import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MainImage from "../layouts/MainImage";
import { GoBriefcase, GoBeaker, GoClock } from "react-icons/go";
import useSEO from "../hooks/useSEO";

function Home() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  // SEO Configuration for Home Page
  useSEO({
    title: "Studio Dentistico Sgarbini Roma - Ambulatorio odontoiatrico",
    description:
      "Studio dentistico a Roma con oltre 20 anni di esperienza. Offriamo servizi di odontoiatria generale, igiene dentale, conservativa e emergenze. Prenota la tua visita in Via Camilla 10/a.",
    keywords:
      "dentista roma, studio dentistico, odontoiatria, igiene dentale, via camilla, dentista qualificato, cure dentali roma",
    schema: {
      "@context": "https://schema.org",
      "@type": "Dentist",
      name: "Studio Dentistico Sgarbini",
      url: window.location.origin,
      logo: `${window.location.origin}/logo192.png`,
      description:
        "Studio dentistico a Roma specializzato in odontoiatria generale e prevenzione",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Via Camilla 10/a",
        addressLocality: "Roma",
        addressRegion: "Lazio",
        postalCode: "00181",
        addressCountry: "IT",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "41.874398",
        longitude: "12.521928",
      },
      telephone: "+39 06 7886902",
      openingHours: ["Mo-Sa 09:00-19:00"],
      priceRange: "€€",
      paymentAccepted: "Cash, Credit Card",
      currenciesAccepted: "EUR",
      areaServed: "Roma",
      medicalSpecialty: "Dentistry",
    },
  });

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div
      id="home-text"
      className={`
        w-full
        bg-black    
        pr-[5%] pl-[5%] 2xl:pr-[25%] 2xl:pl-[25%] 
        pt-[15%]  pb-[15%] 2xl:pb-[8%] 2xl:pt-[8%] 

          flex-grow md:flex
          transition-all duration-700
          ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
        `}
    >
<h2 className="text-center text-xl md:text-2xl lg:text-3xl font-light text-gray-800 text-font-veryLightGrey leading-tight  ">
              {t("home.intro")}
            </h2>

      {/* <div className="flex flex-wrap pt-[15%] md:pt-[8%] pb-[15%] w-full">
        <div className="flex-1 min-w-[300px] flex items-center justify-center w-full">
          <div className="text-center w-full">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-light text-gray-800 text-font-lightGrey leading-tight  ">
              {t("home.intro")}
            </h2>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Home;
